import React from 'react';
import { Link } from 'react-router-dom';

import WheelImg  from "~/assets/images/dailyGoals/wheel-of-fortune.png";
import CheckMark from "../CheckMark";


const SpinTheWheelGoal = ({status})=> {

  return (
    <Link className="item-goal" to={"/games"}>
      <CheckMark done={status} />
      <div>
        <h5 className={"item-title"}> 1 Spin the wheel </h5>
        <p>If you are lucky play at the spinning wheel and win daily tokens</p>
      </div>
      <img src={WheelImg} className="icon"/>
    </Link>

  )
}

export default SpinTheWheelGoal;
